<div id="main" class="internal">
  <div id="home" class="section">
    <div class="content-body">
      <div class="big-button" (click)="goTo('prenotazioni')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-bookmark" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "home.bookings" | translate }}
        </button>
      </div>

      @if (!isRestrictedOperator()) {
        <div
          class="big-button"
          (click)="goTo('ristoranti')"
        >
          <div class="img-button">
            <div class="icon">
              <i class="pi pi-map-marker" style="font-size: 2.5rem"></i>
            </div>
          </div>
          <button class="costa-button">
            {{ "home.restaurants" | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
